import { RelatedEntitiesTile } from "web/components/Tiles"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileSummarySettingsModal } from "./TileSummarySettingsModal"

export default function DealSummaryTile({
  canEdit,
  isTemplate,
  overview,
  tileFetchParams,
  isDoubleColumn,
}) {
  const subjectType = "deal"

  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileSummarySettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  const emptyMessage = `There are no deals for this ${tile.subject_type}`

  return (
    <RelatedEntitiesTile
      tileId={tileFetchParams.id}
      data={tile.data ? [tile.data] : []}
      fields={tile.fields}
      title={tile.name}
      overviewId={overview.id}
      breakoutLink={tile.breakout_link}
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      subjectType={subjectType}
      emptyMessage={emptyMessage}
      isTemplate={isTemplate}
      canEdit={canEdit}
      isDoubleColumn={isDoubleColumn}
    />
  )
}
